module.exports = __webpack_public_path__ + "static/iPad-624bb0a1281ab6cc6bb0ce8478656b67.png";